import type { CaseAgentUIMessage } from "../useCaseAgentChat";

/**
 * Whether the message at `index` opens a reply turn: an assistant message
 * whose nearest shown predecessor is not one too. Hidden system notices (the
 * backend waking the agent) don't break a turn.
 */
export const opensReplyTurn = (
  messages: readonly Pick<CaseAgentUIMessage, "role" | "metadata">[],
  index: number
): boolean => {
  if (messages[index]?.role !== "assistant") return false;
  for (let i = index - 1; i >= 0; i -= 1) {
    const m = messages[i];
    const hidden =
      m.role === "user" &&
      m.metadata?.author?.kind === "system" &&
      !m.metadata?.continued_from;
    if (!hidden) return m.role !== "assistant";
  }
  return true;
};
